import {
  PaymentStatus,
  useGetDownloadTotSpreadsheetLinkQuery,
} from '@/api/ariadne/__generated_types__/apollo';
import * as userSelectors from '@/user/user-selectors';
import { useSelector } from 'react-redux';
import { PaymentPeriodDateRange, QueryFilters } from '../types';

interface Args {
  period: PaymentPeriodDateRange;
  searchQuery: string;
  taxStatus?: PaymentStatus;
  filters: QueryFilters;
}

export function useGetDownloadTotSpreadsheetLink(args: Args) {
  const { period, searchQuery, taxStatus, filters } = args;

  const regionId: string = useSelector(userSelectors.currentCity);

  const { data, error, loading, refetch } =
    useGetDownloadTotSpreadsheetLinkQuery({
      variables: {
        regionId,
        filters: {
          reportingStatus: filters.reportingStatus,
          interest: filters.interest,
          penalties: filters.penalties,
          discrepancy: filters.discrepancy,
          period,
          removeZeroTaxableReceipts: filters.removeZeroTaxableReceipts ?? false,
          searchQuery,
          status: taxStatus ? [taxStatus] : [],
        },
      },
    });

  return {
    totSpreadsheetDownloadLink: data?.region.taxReport.downloadUrl,
    downloadLinkExpiration: data?.region.taxReport.expires,
    isFetchingDownloadLink: loading,
    downloadLinkFetchFailed: !!error,
    refetchDownloadLink: () => {
      refetch();
    },
  };
}
